export default __webpack_public_path__ + "static/media/call-action-right.2674ebaf.png";